import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getproductlist } from "../service/productlist.service";

export const fetchProductList = createAsyncThunk(
  "product/fetchProductList",
  async ({ slug, filters = {} }, { rejectWithValue }) => {
    try {
      return await getproductlist(slug, filters);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const initialState = {
  products: [],
  filters: {},
  selectedFilters: {},
  loading: false,
  error: null,
};

const productSlice = createSlice({
  name: "product",
  initialState,

  reducers: {
    setFilter: (state, action) => {
      const { key, value } = action.payload;
      state.selectedFilters[key] = value;
    },

    clearFilters: (state) => {
      state.selectedFilters = {};
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchProductList.pending, (state) => {
        state.loading = true;
      })

      .addCase(fetchProductList.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload.qualities || [];
        state.filters = action.payload.filters || {};
      })

      .addCase(fetchProductList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setFilter,
  clearFilters,
} = productSlice.actions;

export default productSlice.reducer;